import React, { useEffect, useState } from 'react';

// Material UI
import { Grid, FormHelperText, IconButton, TextField, Button, Stack, Paper, Container, Select, MenuItem, InputLabel, FormControl } from '@mui/material';
import LoginIcon from '@mui/icons-material/Login';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import { getMessages, updateObject } from '../../shared/utils/utility';

import { useForm, Controller, useController } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { validateField, validate } from '../../shared/utils/validations/validation';
import * as authService from '../api/api';
import LocalStorageService from '../../shared/services/localStorageService';
import { Navigate,useNavigate,useLocation } from 'react-router-dom';
import MyLoading from '../../shared/components/myLoading';
import MyCard from '../../shared/components/myCard';
import { styled } from '@mui/material/styles';
import {AuthContext} from './AuthContext';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as LogoIcon } from '../../assets/imgs/rentgologo.svg';
const LoginBox = {
  marginTop: '20px',
};
const defaultInputValues = {
  email: '',
  password: '',
};

const ForgetPassword = (props) => {
 
  let navigateHook = useNavigate();
  let location = useLocation();
  var pr = new URLSearchParams(useLocation().search);
  console.log(pr.get('p'),"loclo");

  const [token,setToken] = useState( pr.get('tkn'));


  let { from } = location.state || { from: { pathname: "/" } };
  const [isLoading, setIsLoading] = useState(false);
  
  const [isCloseForm, setIsCloseForm] = useState(false);
 
  const {
    authUser,loginUser,logoutUser
  } = React.useContext(AuthContext);
 
    const validationSchema = Yup.object().shape({
        TextFieldEmail: Yup.string().email('Eposta yanlış formatta').required('Email  girmelisiniz'),
        TextFieldNewPassword: Yup.string().min(5, 'Şifre 5 karakterden uzun olmalıdır'),
        TextFieldNewPasswordAgain: Yup.string()
        
      });
 
  const {
    register,
    handleSubmit,
    control,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({ defaultValues: defaultInputValues, resolver: yupResolver(validationSchema) });

 
  const handleSendTokenToEmail = async () => {

    if(getValues('TextFieldEmail')=="")
      toast.error("Mail kısmını doldurunuz yenileme linkini mail adresinize göndereceğiz.")
      else{
        authService.forgetPassword(getValues('TextFieldEmail')).then((res) => {
          const { isSuccess, message, data } = res;
          if (isSuccess) {
            toast.success("Şifre yenilme linki mail adresinize gönderildi");
            setIsCloseForm(true);
          }
          else{
            toast.error("Kontrol ediniz");
          }
        });
      }
  }
  const handleChangePassword = async () => {

    if(getValues('TextFieldEmail')=="")
      toast.error("Mail kısmını doldurunuz yenileme linkini mail adresinize göndereceğiz.");
    
    else if(getValues('TextFieldNewPassword')=="" || getValues('TextFieldNewPasswordAgain')=="")
        toast.error("Şifre ve Şifre Tekrar alanlarını doldurunuz");
    else if(getValues('TextFieldNewPassword')!=getValues('TextFieldNewPasswordAgain'))
        toast.error("Girilen şifreler uyuşmamaktadır");
      else{
        authService.resetPassword(getValues('TextFieldEmail'),token,getValues('TextFieldNewPassword')).then((res) => {
          const { isSuccess, message, data } = res;
          if (isSuccess) {
            toast.success("Şifreniz başarıyla değiştirildi");
            setIsCloseForm(true);
          }
          else{
            toast.error("Hata şifreniz değiştirilemedi");
          }
        });
      }
  }

  
  
  return (
    <>
     

      {isLoading && <MyLoading />}
      {!isLoading && (
        <Container noValidate autoComplete="off">
      
          { 
          <Grid container spacing={3} direction="column" justify-content="center" alignItems="center">
       
       {
        pr.get('tkn')===null ?
       
            <Grid item xs={6}>
                {!isCloseForm?
              <MyCard header="Kullanıcı Bilgileri">
                <Grid container spacing={2}>
           
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      id="outlined-basic"
                      name="TextFieldEmail"
                      label="Email"
                      variant="outlined"
                      size="small"
                      type="text"
                      {...register('TextFieldEmail')}
                      error={errors.TextFieldEmail ? true : false}
                      helperText={errors.TextFieldEmail?.message}
                    />
                  </Grid>
                 
                  <Grid item xs={6}>
                    <Button variant="outlined" onClick={handleSubmit(handleSendTokenToEmail)} endIcon={<LoginIcon />}>
                      Şifremi Unuttum
                    </Button>
                   
                  </Grid>



                
                </Grid>
              </MyCard>
              :<div>Şifre yenilme linki mail adresinize gönderildi</div>
}
              <Grid container spacing={3} direction="column" justify-content="center" alignItems="center">
              <Grid item xs={12} marginTop={5}>
                <svg xmlns="http://www.w3.org/2000/svg" width="200" height="60"  style={{  justifyContent: 'left',}}>
                <SvgIcon component={LogoIcon}   inheritViewBox  width="100%" height="100%"  
/></svg>
                </Grid>
                </Grid>
            </Grid>
            :
            <Grid item xs={6}>

<MyCard header="Kullanıcı Bilgileri">
                <Grid container spacing={2}>
           
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      id="outlined-basic"
                      name="TextFieldEmail"
                      label="Email"
                      variant="outlined"
                      size="small"
                      type="text"
                      {...register('TextFieldEmail')}
                      error={errors.TextFieldEmail ? true : false}
                      helperText={errors.TextFieldEmail?.message}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      id="outlined-basic"
                      name="TextFieldNewPassword"
                      label="Yeni Şifre"
                      variant="outlined"
                      size="small"
                      type="password"   
                      {...register('TextFieldNewPassword')}
                      error={errors.TextFieldNewPassword ? true : false}
                      helperText={errors.TextFieldNewPassword?.message}                 
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      id="outlined-basic"
                      name="TextFieldNewPasswordAgain"
                      label="Yeni Şifre Tekrar"
                      variant="outlined"
                      size="small"
                      type="password"   
                      {...register('TextFieldNewPasswordAgain')}
                      error={errors.TextFieldNewPasswordAgain ? true : false}
                      helperText={errors.TextFieldNewPasswordAgain?.message}                 
                    />
                  </Grid>
                 
                  <Grid item xs={6}>
                    <Button variant="outlined" onClick={handleSubmit(handleChangePassword)} endIcon={<LoginIcon />}>
                      Şifre Değiştir
                    </Button>
                   
                  </Grid>



                
                </Grid>
              </MyCard>


            </Grid>
}



          </Grid>  
        
}
        </Container>
      )}
    </>
  );
};

export default ForgetPassword;
